<div class="container">
  <div>
    <h1 class="welcome-header">Welcome, {{ userFirstName }}</h1>
    <ng-container *ngIf="($hasPolicyData | async) === false">
      <app-no-content-page message="Policy is not available for viewing."></app-no-content-page>
    </ng-container>
    <ng-container *ngIf="$hasPolicyData | async">
      <div id="policy-manager-container">
        <dxo-card bodyHeader="Policy at a glance">
          <card-body>
            <div class="data-containter">
              <ng-container *ngIf="overviewData">
                <dxo-label-value
                  [label]="overviewData.status.label ?? ''"
                  [tooltipContent]="{ heading: 'Policy number', body: 'This is your policy number.' }"
                  [values]="[overviewData.status.data]"
                ></dxo-label-value>
                <div></div>
                <dxo-label-value
                  [label]="overviewData.policyHolder.label ?? ''"
                  [values]="[overviewData.policyHolder.data]"
                ></dxo-label-value>
                <dxo-label-value
                  [label]="overviewData.policyNumber.label ?? ''"
                  [values]="[overviewData.policyNumber.data]"
                ></dxo-label-value>
                <dxo-label-value
                  [label]="overviewData.effectiveDate.label ?? ''"
                  [tooltipContent]="{ heading: 'Effective date', body: 'This is your effective date.' }"
                  [values]="[overviewData.effectiveDate.data]"
                ></dxo-label-value>
                <dxo-label-value
                  [label]="overviewData.nextRenewalDate.label ?? ''"
                  [tooltipContent]="{ heading: 'Renewal date', body: 'This is your renewal date.' }"
                  [values]="[overviewData.nextRenewalDate.data]"
                ></dxo-label-value>
              </ng-container>
              <div class="data-title"></div>
              <div class="data-value"></div>
            </div>
          </card-body>
          <a href="#" class="link">More on Policy Information</a>
        </dxo-card>

        <dxo-card bodyHeader="Your account manager" icon="contacts">
          <card-body>
            <div class="manager-conatiner">
              <ng-container *ngIf="managerData">
                <dxo-label-value
                  [label]="managerData.managerName.label ?? ''"
                  [tooltipContent]="{ heading: 'Name', body: 'This is your manager name' }"
                  [values]="[managerData.managerName.data]"
                ></dxo-label-value>

                <div class="email">
                  <dxo-label-value
                    [label]="managerData.managerEmail.label ?? ''"
                    [values]="[managerData.managerEmail.data]"
                  ></dxo-label-value>
                </div>
                <dxo-label-value
                  [label]="managerData.managerPhoneNumber.label ?? ''"
                  [values]="[managerData.managerPhoneNumber.data]"
                ></dxo-label-value>
              </ng-container>
            </div>
          </card-body>
        </dxo-card>

        <dxo-card bodyHeader="Payments">
          <div class="data-containter">
            <div class="payments">
              <ng-container *ngIf="paymentsData">
                <dxo-label-value
                  [label]="paymentsData.estimatedPayment.label ?? ''"
                  [values]="[paymentsData.estimatedPayment.data]"
                  [subValue]="'Due ' + paymentsData.due.data"
                ></dxo-label-value>
              </ng-container>
            </div>
            <div class="payments">
              <ng-container *ngIf="paymentsData">
                <dxo-label-value
                  [label]="paymentsData.lastPayment.label ?? ''"
                  [values]="[paymentsData.lastPayment.data]"
                  [subValue]="'Paid ' + paymentsData.paid.data"
                ></dxo-label-value>
              </ng-container>
            </div>
            <ng-container *ngIf="paymentsData">
              <dxo-label-value
                [label]="paymentsData.billingMethod.label ?? ''"
                [values]="[paymentsData.billingMethod.data]"
                [tooltipContent]="{ heading: 'Renewal date', body: 'This is your renewal date.' }"
                [subValue]="'Paid ' + paymentsData.paid.data"
              ></dxo-label-value>
            </ng-container>
            <dxo-button>Make a payment</dxo-button>
            <a href="#" class="link">More on Billing</a>
          </div>
        </dxo-card>
      </div>
    </ng-container>
  </div>
</div>
